import React from "react";
import { Row, Col } from "react-bootstrap";
import AverageSalesData from "../AverageSalesData";
import MarketCount from "../MarketCount";

export default function SalesFiguresPane({ product, productChartsUrl }) {
  const {
    absoluteSellingMerchantStoreCount,
    averageSalesCountPerStorePerWeek,
  } = product;

  if (!absoluteSellingMerchantStoreCount) {
    return (
      <SimpleSalesFiguresPaneLayout>
        <small>Keine Abverkaufsdaten vorhanden</small>
      </SimpleSalesFiguresPaneLayout>
    );
  }

  if (!product.isLive) {
    return (
      <SimpleSalesFiguresPaneLayout>
        <small>Abverkaufsdaten erst nach Veröffentlichung einsehbar</small>
      </SimpleSalesFiguresPaneLayout>
    );
  }

  return (
    <Row className="recommendations pricing">
      <Col xs={4}>
        <AverageSalesData
          averageSalesCountPerStorePerWeek={averageSalesCountPerStorePerWeek}
          productChartsUrl={productChartsUrl}
        />
      </Col>
      <Col xs={4}>
        <MarketCount
          absoluteSellingMerchantStoreCount={absoluteSellingMerchantStoreCount}
          productChartsUrl={productChartsUrl}
        />
      </Col>
      <Col xs={4}>
        <small>
          <a href={productChartsUrl}>Alle Abverkaufsdaten anschauen</a>
        </small>
      </Col>
    </Row>
  );
}

const SimpleSalesFiguresPaneLayout = ({ children }) => (
  <Row className="inavailable_recommmendations">
    <Col xs={12}>{children}</Col>
  </Row>
);
